export enum EnvironmentTypes {
  Production = 'prod',
  Test = 'test',
  Stage = 'stage',
  Development = 'dev',
}
